import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GLIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GL" {...props}>
    <Path fill="#fff" d="M0 0h18v12H0z" />
    <Path fill="#C8102E" d="M0 6h18v6H0zm3 0a4 4 0 0 0 8 0 4 4 0 0 0-8 0" />
  </Icon>
);
